import { render, staticRenderFns } from "./AddLicense.vue?vue&type=template&id=99f45692"
import script from "./AddLicense.vue?vue&type=script&lang=js"
export * from "./AddLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports